import { Flex, Text, ThemeIcon } from '@mantine/core';
import { IconListSearch } from '@tabler/icons-react';

export const EmptyMessage = () => {
  return (
    <Flex align='center' gap={16} wrap='nowrap'>
      <ThemeIcon bg='primary.0' c='tertiary.6' size={48} radius='50%'>
        <IconListSearch size={32} />
      </ThemeIcon>

      <Flex direction='column' gap={4} style={{ flex: 1, minWidth: 0 }}>
        <Text size='md' fw={600} c='tertiary.7'>
          Список кандидатов пуст
        </Text>
        <Text size='sm' c='tertiary.7'>
          Для выбора найдено «0» кандидатов
        </Text>
      </Flex>
    </Flex>
  );
};
